import { PLAN_KEY } from '../../../../modules/plan/model'
import { WORKOUT_KEY } from '../../../../modules/workout/model'
import getPlannedAtWorkoutUtil from '../../../../modules/workout/model/utils/get-planned-at'
import PLANS_ACTION from '../../constants/action'
import getAllWorkoutsPlanSelector from '../../selectors/get-all-workouts'
import getCurrentPlanSelect from '../../selectors/get-current'
import getWorkoutLogsPlanSelector from '../../selectors/get-workout-logs'
import updateReduxAction from '../../../redux/actions/update'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import { getValueReduxUtil } from '../../../redux/utils/get-value'
import { differenceInWeeksDateUtil, logUtil } from 'packages/src'

function getKeyToDurationMap (workouts, key) {
  return workouts.reduce((obj, workout) => {
    const o = getValueReduxUtil(workout, key)
    if (!o) {
      return obj
    }
    Object.keys(o)
      .forEach(key => {
        const value = obj[key] || 0
        obj[key] = value + o[key]
      })
    return obj
  }, {})
}

function getWeeksCount (workouts) {
  if (!workouts.length) {
    return 0
  }
  const firstWorkout = workouts[0]
  const firstWorkoutPlannedAt = getPlannedAtWorkoutUtil(firstWorkout)
  const lastWorkout = workouts[workouts.length - 1]
  const lastWorkoutPlannedAt = getPlannedAtWorkoutUtil(lastWorkout)
  return differenceInWeeksDateUtil(new Date(lastWorkoutPlannedAt),
    new Date(firstWorkoutPlannedAt)
  ) + 1
}

function updateDataPlanAction (planParam) {
  return (dispatch, getState) => {
    const plan = planParam || getCurrentPlanSelect(getState())
    if (!plan) {
      logUtil('').info('plan not found: ', planParam)
      return
    }

    const workouts = getAllWorkoutsPlanSelector(plan)(getState())
    const workoutLogs = getWorkoutLogsPlanSelector(plan)(getState())
    const newWorkoutsCompletedCount = workoutLogs.length
    const newWorkoutsCount = newWorkoutsCompletedCount > workouts.length
      ? newWorkoutsCompletedCount
      : workouts.length

    // Update the data
    const updates = {
      [PLAN_KEY.WORKOUTS_COUNT]: newWorkoutsCount,
      [PLAN_KEY.WORKOUTS_COMPLETED_COUNT]: newWorkoutsCompletedCount,
      [PLAN_KEY.WEEKS_COUNT]: getWeeksCount(workouts),
      [PLAN_KEY.EQUIPMENT]: getKeyToDurationMap(workouts,
        WORKOUT_KEY.EQUIPMENT
      ),
      [PLAN_KEY.TYPES]: getKeyToDurationMap(workouts, WORKOUT_KEY.TYPES),
      [PLAN_KEY.MUSCLES]: getKeyToDurationMap(workouts, WORKOUT_KEY.MUSCLES)
    }

    dispatch(updateReduxAction({
      type: PLANS_ACTION.UPDATE_DATA,
      payload: {
        path: getPathReduxUtil(plan),
        updates
      }
    }))
  }
}

export default updateDataPlanAction
